<h3 style="margin-top: 100px;margin-left: 210px;">Contact Us</h3>
<div class="container">
    <div class="row">
    <div class="col-md-8">
       
    <p style="margin-top: 10px;">
    Apptunix is a software development and designing service provider company. 
    Apptunix is founded by a young and energetic entrepreneur focused on leveraging 
    its customer with state of the art technology by offering innovative, contemporary 
    and cost-effective technology solutions.

    Apptunix is a leading Mobile App Development Company. We have a highly skilled team of 
    developers that always looking for bigger challenges. We provide top-line mobile development
    services at competitive prices. We’ve worked on a number of challenging projects and lived 
    up to our client’s expectations time and time again.
    </p>
</div>
</div>
</div>
<footer>
    <div class="top_header" style="margin-top: 100px;">
    <section>
    <span><i class="fa fa-map-marker"></i></span>
    <span>3rd Floor, C-127, Phase-8, Industrial Area, Sector 73, Sahibzada Ajit Singh Nagar, Punjab 160071</span>
    </section>
    <section>
    <span><i class="fa fa-phone"></i></span>
    <span>(91) 0172 400 8203</span>
    </section>
    <section>
    <span><i class="fa fa-envelope"></i></span>
    <span>hr@apptunix.com</span>
    </section>
    </div>
    <span class="border-shape"></span>
    <div class="bottom_content">
    <section>
    <a href="#"><i class="fa fa-facebook"></i></a>
    <a href="#"><i class="fa fa-instagram"></i></a>
    <a href="#"><i class="fa fa-twitter"></i></a>
    <a href="#"><i class="fa fa-telegram"></i></a>
    </section>
    <section>
    <a href="#">Home</a>
    <a href="#">About us</a>
    <a href="#">Order</a>
    <a href="#">Retail</a>
    <a href="#">Member</a>
    <a href="#">Contact Us</a>
    </section>
    </div>
    <div class="copyright">
    Copyright © 2022 apptunix - All rights reserved 
    </div>
    </footer>
